import {PlatformDataType, RetrievePlatformDataType} from 'src/interfaces/Platform.interface'
import {remapLegacyRoleDisplayText} from 'src/utils/platformRoleDisplay'

export const SELECTED_PLATFORM_LABEL = 'Selected Platform'
export const RELATED_PLATFORM_LABEL = 'Related Platform'

/** Fields used for display-text substitution. Structural so callers can pass partial platform records. */
export type PlatformSettingDisplayPlatform = {
  display_name?: string | null
  platform_info?: {display_name?: string | null} | null
} | null

export type PlatformSettingDisplayContext = {
  retrievedPlatform?: RetrievePlatformDataType | PlatformDataType | PlatformSettingDisplayPlatform
  mainStore?: PlatformDataType | PlatformSettingDisplayPlatform
  sourceChannelName?: string | null
}

const nonBlank = (value: unknown, fallback: string): string => {
  if (typeof value !== 'string') return fallback
  const trimmed = value.trim()
  return trimmed ? trimmed : fallback
}

/**
 * Whole-bracket tokens only. Longer names are listed first so
 * [user_channel_name] is not treated as [channel_name].
 */
const PLATFORM_SETTING_SHORTCODE_PATTERN =
  /\[(related_user_channel_name|related_channel_name|user_channel_name|source_channel_name|channel_name)\]/g

const resolvePlatformSettingShortcode = (
  token: string,
  context: PlatformSettingDisplayContext
): string => {
  switch (token) {
    case '[channel_name]':
      return nonBlank(
        context.retrievedPlatform?.platform_info?.display_name,
        SELECTED_PLATFORM_LABEL
      )
    case '[user_channel_name]':
      return nonBlank(context.retrievedPlatform?.display_name, SELECTED_PLATFORM_LABEL)
    case '[related_channel_name]':
      return nonBlank(context.mainStore?.platform_info?.display_name, RELATED_PLATFORM_LABEL)
    case '[related_user_channel_name]':
      return nonBlank(context.mainStore?.display_name, RELATED_PLATFORM_LABEL)
    case '[source_channel_name]':
      return nonBlank(context.sourceChannelName, SELECTED_PLATFORM_LABEL)
    default:
      return token
  }
}

/** Display-text substitution for setting titles, notes, tooltips, placeholders, and option labels. */
export const applyPlatformSettingShortcodes = (
  text: string | null | undefined,
  context: PlatformSettingDisplayContext = {}
): string => {
  if (text == null || text === '') return ''

  const replaced = String(text).replace(PLATFORM_SETTING_SHORTCODE_PATTERN, (token) =>
    resolvePlatformSettingShortcode(token, context)
  )

  return remapLegacyRoleDisplayText(replaced)
}
